const ExternalVehicleDetails = {
    number_of_doors: {
        label: 'Doors',
    },
    fuel_type: {
        label: 'Fuel Type',
    },
    fuel_capacity: {
        label: 'Fuel Capacity',
    },
    city_mileage: {
        label: 'City Mileage',
    },
    highway_mileage: {
        label: 'Highway Mileage',
    },
    engine: {
        label: 'Engine',
    },
    engine_size: {
        label: 'Engine Size',
    },
    engine_cylinders: {
        label: 'Engine Cylinders',
    },
    transmission_full_name: {
        label: 'Transmission',
    },
    transmission: {
        label: 'Transmission Type',
    },
    transmission_speeds: {
        label: 'Transmission Speeds',
    },
    drive: {
        label: 'Drivetrain',
    },
    anti_brake_system: {
        label: 'Anti Brake System',
    },
    steering_type: {
        label: 'Steering Type',
    }
};

export default ExternalVehicleDetails
